module.exports = "<input type=\"text\" (keyup)=\"onKeyup($event)\">\r\n<button (click)=\"getUsers()\">Search</button>\r\n<hr>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/search/search.component.html
// module id = ../../../../../src/app/_components/search/search.component.html
// module chunks = 1